app.directive("acSearch", ['$rootScope', '$timeout', function($rootScope, $timeout) {
    return {
        compile: function(element, attributes) {
            return {
                pre: function(scope, element, attributes) {
                    if(scope.searches == undefined){
                        scope.searches = {};
                    }
                    
                    if(window.searches == undefined){
                        window.searches = {};
                    }
                    var myName = attributes.acSearch;
                    scope.searches[myName] = {};
                    if(window.searches[myName] == undefined){
                        window.searches[myName] = {};
                    }
                    
                    scope.searches[myName].searchField = "";
                    scope.searches[myName].adapter = {};
                    scope.searches[myName].result = undefined;
                    window.searches[myName].result = scope.searches[myName].result;
                    //window.searches[myName] = scope.searches[myName]

                    scope.searches[myName].adapter.resultSelected = function(object, key){
                        scope.searches[myName].result = object;
                        window.searches[myName].result = object;
                        if(key != undefined){
                             scope.searches[myName].searchField = object[key]
                        }
                        
                        if(attributes.acSearchIsLiveSearch == undefined){
                            //HACK == BUG
                            console.log(scope)
                            if(scope.addUser != undefined){
                                scope.addUser(object)
                            }
                            if(window.searches[myName].selectListener != undefined){
                                //window.searches[myName].selectListener()
                            }else{
                                eval("scope."+attributes.acChange)
                            }
                            
                        }else{
                            eval("scope."+attributes.acSearchSelected);
                        }
                        
                    }
                    //GUI stuff
                    var searchField = element.find(".searchField");
                    searchField.bind("click", function(event) {
                        var menuName = attributes.acSearch;
                        var dropDown = $("[ac-menu='"+menuName+"']")
                        $timeout(function(){
                            dropDown.addClass("mdc-menu-surface--open")
                        },100)
                        
                    })
                    
                    searchField.bind("keyup", function(event) {
                        var menuName = attributes.acSearch;
                        var dropDown = $("[ac-menu='"+menuName+"']")
                        console.log(dropDown)
                        dropDown.addClass("mdc-menu-surface--open")
                        
                        if(attributes.acSearchIsLiveSearch != undefined){
                            eval("scope."+attributes.acChange)
                        }
                    })
                    
                    var item = element.find(".mdc-menu-surface");
                    item.bind("click", function(event){
                        var input = element.find("input");
                        input.addClass("ng-touched");
                        input.addClass("ng-not-empty");
                        
                        var label = element.find(".mdc-floating-label");
                        label.addClass("mdc-floating-label--float-above");
                        var dropDown = element.find(".mdc-menu-surface");
                        dropDown.removeClass("mdc-menu-surface--open")
                    })
                }
            }
        }
    }
}]);